import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'COLLABORATION_UPDATE',
    smsDelete : 'COLLABORATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        collaboration:[],
      
        collaboration_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        collaborationLoading: false,
        collaborationError: false,

        
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_COLLABORATION(state, collaboration) {
            state.collaboration = collaboration;
        },

        SET_COLLABORATION_DETAIL(state, detail) {
            state.collaboration_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },


        COLLABORATION_LOADING (state, loading) {
            state.collaborationLoading = loading;
        },

        COLLABORATION_ERROR (state, hasError) {
            state.collaborationError = hasError;
        },
        


       
    },

    actions: {
        //Collaboration
        async addCollaboration ({commit, dispatch}, payload) {
            commit('COLLABORATION_LOADING', true);
            commit('COLLABORATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_collaboration, payload.collaboration, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCollaboration')
               
                return response

            }catch (e) {
                commit('COLLABORATION_ERROR', true);
            }finally {
                commit('COLLABORATION_LOADING', false);
            }
        },

        async fetchCollaborationDetail ({ commit },payload) {
            commit('COLLABORATION_LOADING', true);
            commit('COLLABORATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_collaboration_details + payload, config);
                let response = result.data.data

                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('COLLABORATION_ERROR', true);
            }
            finally {
                commit('COLLABORATION_LOADING', false);
            }
        },



        async fetchCollaboration ({ commit }) {
            commit('COLLABORATION_LOADING', true);
            commit('COLLABORATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.collaboration_list, config);
                let response = result.data

                commit('SET_COLLABORATION', response.data);

            } catch(error) {
                commit('COLLABORATION_ERROR', true);
            }
            finally {
                commit('COLLABORATION_LOADING', false);
            }
        },


    
        async updateCollaboration ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {

                let response = await axios.patch(V1API.update_collaboration+payload.id, payload.collaboration, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCollaboration')
                return response

            }catch (e) {
                commit('COLLABORATION_ERROR', true);
            }finally {
                commit('COLLABORATION_LOADING', false);
            }
        },

        
        async deleteCollaboration({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.collaboration_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCollaboration')
            
            return response
        },




    },

    getters: {}
}
